import { StringParam } from 'use-query-params';

export const queryParams = {
  rawTransactionId: StringParam,
};
